import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  getCompanyLogo,
  companyLogoUpload,
} from "../../../services/commonController";
import { REACT_APP_BASE_BACKEND_URL } from "../../../config";
import { Dropdown as Select, Toast } from "../../../PrimeReactComponents";
import Loader from "../../../features/loader/Loader";
let BASE_BACKEND_URL = REACT_APP_BASE_BACKEND_URL;

function LogoManagement() {
  const toast = useRef(null);
  const fileInputRef = useRef(null);
  const [loader, setLoader] = useState();
  const { transportUserInfo } = useSelector((state) => state);
  const reciveLocalData = transportUserInfo.company_id;
  const [logo, setLogo] = useState(null);
  const [preview, setPreview] = useState(null);
  const company_id = reciveLocalData;
  const handleFileChange = (event) => {
    const file = event.target.files?.[0];

    if (!file) {
      return;
    }

    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];

    const MAX_SIZE =
      Number(process.env.REACT_APP_LOGO_MAX_SIZE_MB || 2) * 1024 * 1024;

    const MAX_WIDTH = Number(process.env.REACT_APP_LOGO_MAX_WIDTH || 250);

    const MAX_HEIGHT = Number(process.env.REACT_APP_LOGO_MAX_HEIGHT || 150);

    // Validate file type
    if (!allowedTypes.includes(file.type)) {
      toast.current.show({
        severity: "error",
        summary: "Info Message",
        detail: "Please upload a PNG, JPG, JPEG or WEBP image.",
        life: 3000,
      });

      event.target.value = "";
      return;
    }

    // Validate file size
    if (file.size > MAX_SIZE) {
      toast.current.show({
        severity: "error",
        summary: "Info Message",
        detail: "Logo size should not exceed 2 MB.",
        life: 3000,
      });

      event.target.value = "";
      return;
    }

    // Validate image dimensions
    const image = new Image();
    const imageUrl = URL.createObjectURL(file);

    image.onload = () => {
      const width = image.naturalWidth;
      const height = image.naturalHeight;

      if (width > MAX_WIDTH || height > MAX_HEIGHT) {
        toast.current.show({
          severity: "error",
          summary: "Invalid Dimensions",
          detail: `Logo dimensions should not exceed ${MAX_WIDTH}px × ${MAX_HEIGHT}px. Uploaded image is ${width}px × ${height}px.`,
          life: 4000,
        });

        event.target.value = "";
        URL.revokeObjectURL(imageUrl);
        return;
      }

      // All validations passed
      setLogo(file);
      setPreview(imageUrl);
    };

    image.onerror = () => {
      toast.current.show({
        severity: "error",
        summary: "Invalid Image",
        detail: "Unable to read the selected image.",
        life: 3000,
      });

      event.target.value = "";
      URL.revokeObjectURL(imageUrl);
    };

    image.src = imageUrl;
  };
  const getCompanyLogoData = async (company_id) => {
    setLoader(true);
    const results = await getCompanyLogo(company_id);
    let logoUrl = "";
    if (results?.data?.company_logo) {
      logoUrl = BASE_BACKEND_URL + results?.data?.company_logo;
    }
    setPreview(logoUrl);
    setLoader(false);
  };
  useEffect(() => {
    getCompanyLogoData(company_id);
  }, [company_id]);
  const handleUpload = async () => {
    setLoader(true);
    if (!logo) {
      toast.current.show({
        severity: "error",
        summary: "Info Message",
        detail: "Please select a logo.",
        life: 3000,
      });
      setLoader(false);
      return;
    }
    const headers = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const formData = new FormData();
    formData.append("logo", logo);
    try {
      const response = await companyLogoUpload(company_id, formData, headers);
      if (response.error !== null) {
        toast.current.show({
          severity: "error",
          summary: "Info Message",
          detail: response.message,
          life: 3000,
        });
      } else {
        toast.current.show({
          severity: "success",
          summary: "Info Message",
          detail: response.message,
          life: 3000,
        });
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      toast.current.show({
        severity: "error",
        summary: "Info Message",
        detail: "Failed to upload logo.",
        life: 3000,
      });
    }
  };

  return (
    <>
      <Loader show={loader} />
      <Toast ref={toast} position="top-center" />
      <div className="card">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h3 className="mb-1">Logo Management</h3>
              <p className="text-muted mb-0">
                Upload and manage your transport logo.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group mb-4">
                <label className="form-label fw500">Upload Logo</label>

                <input
                  ref={fileInputRef}
                  type="file"
                  className="form-control"
                  accept=".png,.jpg,.jpeg,.webp,image/png,image/jpeg,image/webp"
                  onChange={handleFileChange}
                />

                <small className="text-muted">
                  Supported formats: PNG, JPG, JPEG, WEBP. Maximum size:
                  {Number(process.env.REACT_APP_LOGO_MAX_SIZE_MB || 2)} MB.
                  Maximum dimensions:{" "}
                  {Number(process.env.REACT_APP_LOGO_MAX_WIDTH || 250)} ×{" "}
                  {Number(process.env.REACT_APP_LOGO_MAX_HEIGHT || 150)} px.
                </small>
              </div>

              {preview && (
                <div className="mb-4">
                  <label className="form-label fw500">Logo Preview</label>

                  <div
                    className="border rounded p-4 d-flex justify-content-center align-items-center"
                    style={{
                      minHeight: "180px",
                      background: "#f8f9fa",
                    }}
                  >
                    <img
                      src={preview}
                      alt="Logo Preview"
                      style={{
                        maxWidth: "250px",
                        maxHeight: "120px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                </div>
              )}

              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="bg-green text-white btn fz14  btn"
                  onClick={handleUpload}
                  disabled={!logo}
                >
                  <i className="fa-light fa-upload me-2"></i>
                  Upload Logo
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LogoManagement;
